var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "278px",
    height: "175px",
    viewBox: "0 0 278 175",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "undraw_heavy_box_agqi (2)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Customer-Tracking---008",
    transform: "translate(-549.000000, -296.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(485.000000, 226.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_heavy_box_agqi-(2)",
    transform: "translate(64.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.18939,132 C225.635385,103.454332 222.172924,71.5799507 207.410681,47.0997796 L52.8818185,68.4435548 L200.969839,37.656836 C138.556986,-39.9815371 17.0794841,11.515035 28.7893081,109.539 L214.18939,132 Z",
    id: "Path",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EB5E55",
    x: 24,
    y: 101,
    width: 197,
    height: 61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8283105,93 C80.5991661,94.2946866 81.246717,94.7126464 81.6238297,94.6595991 C99.8952676,99.6688618 83.8776534,105.539337 75,95.5744282 L78.8283105,93 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB8B8",
    points: "19 148.962873 19 161 28 160.518563 25.5001751 148"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB8B8",
    points: "69 148.962873 69 161 60 160.518563 62.5000525 148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4382064,84.5 L54.8095211,84 C85.6554373,116.648766 73.9901416,109.202208 73.1331762,154 L56.7904579,149 L60.257098,118 C60.258859,117.998822 61.1715442,117.384507 60.4128986,117.370347 C55.6681694,119.016572 52.2062688,98.6340752 41.9334273,101 C30.2434752,100.435428 28.3403763,117.943754 23.6097722,118 L27.0764311,149 L10.7337034,154 C8.90390562,104.771774 -0.0639924024,115.892494 29.0573585,84 L41.4382064,84.5 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.345252,157.554507 C21.345252,157.554507 19.3545516,153.563089 16.8661729,155.558799 C14.3777942,157.55451 8.40568668,163.541636 8.40568668,163.541636 C8.40568668,163.541636 -6.02690709,170.027695 2.93125424,174.01912 C11.8894156,178.010545 19.3545516,168.530918 19.3545516,168.530918 C27.8870751,166.747191 32.8086725,165.605218 28.2837336,156.27463 C25.7147487,157.389102 22.0792454,158.679356 21.345252,157.554507 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.654748,157.554507 C66.654748,157.554507 68.6454484,153.563089 71.1338271,155.558799 C73.6222058,157.55451 79.5943133,163.541636 79.5943133,163.541636 C79.5943133,163.541636 94.0269071,170.027695 85.0687458,174.01912 C76.1105844,178.010545 68.6454484,168.530918 68.6454484,168.530918 C60.1129249,166.747191 55.1913275,165.605218 59.7162664,156.27463 C62.2852513,157.389102 65.9207546,158.679356 66.654748,157.554507 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,29.0000139 C54.2563465,41.5459326 37.2688169,40.4413879 37,28.9999122 C37.743581,16.454092 54.7311106,17.5586368 55,29.0000139 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,35.5 C46.3740961,48.720054 36.0470882,41.5226086 50.5,52 L56,41 C56,41 52,39.5 52.5,34 L42,35.5 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9052472,42.4126694 L54.1973477,39 C54.6110242,48.015173 45.1468505,46.2007357 43.4954541,41.6658821 L29.4337432,49.9360796 C35.3358606,72.2819909 33.8400529,73.2039989 25.9799842,87.5531211 C22.9802687,90.3377036 27.4663977,91.9336558 31.3718517,90.4099301 C34.3506138,88.5410281 35.8633684,86.8802298 39.0551668,87.3028438 C54.1372281,90.4952162 66.6928101,91.2487326 68.6798181,90.0013086 C69.3908389,88.9668675 68.6592349,42.5922411 68.9052472,42.4126694 Z",
    id: "Path",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,43.2066043 C65.5,43.2066043 68.0755767,42 68.0755767,42 C75.5689179,41.8744034 80.5974477,92.0860538 81,93.5133884 L76,97 L68,76.5784326 L65,43.2066043 Z",
    id: "Path",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,102.011867 C30.2416536,103.921283 30.652882,125.363966 37.8284219,115.347609 C38.7698401,108.039969 35.569151,105.858464 34.7262268,101 L30,102.011867 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9781488,49.8399218 L30.4394586,49.0012287 C26.3142796,48.8679622 27.6143643,59.603885 25.8690842,67.4662106 C24.443268,76.6256091 24.849242,86.7252413 26.5220442,100.227923 C26.6683329,105.182855 35.694973,102.061346 37,101.682521 C37,101.682521 33.986888,81.439219 35.4934456,77.9830461 C37,74.5268733 31.9781488,49.8399218 31.9781488,49.8399218 Z",
    id: "Path",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8747384,20.0567276 C52.5082402,17.7881963 50.3692622,16.116532 47.8694875,15.3634753 L46.0334418,16.8650591 L46.7472653,15.1136305 C46.146974,15.0200113 45.5394209,14.9841142 44.9325763,15.0064101 L43.2806034,17.1777481 L43.9643308,15.080786 C36.8757087,15.8588928 32.6817341,24.1778014 36.3618078,30 C36.9294913,28.2165673 37.6184804,26.5431079 38.1861638,24.7596562 C38.6323123,24.8218327 39.0844998,24.8240846 39.5312197,24.7663545 L40.2218933,23.118886 L40.4148171,24.6966757 C42.5555028,24.5059961 45.7306694,24.0874219 47.760126,23.7038838 L47.5627968,22.4935017 L48.7434521,23.4993286 C49.3652377,23.352984 49.7343976,23.2203056 49.703892,23.118886 C51.2132337,25.606389 52.7087605,27.1952093 54.2180649,29.6826964 C54.7910193,26.1740004 55.8024622,23.2574635 53.8747384,20.0567276 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 166,
    y: 108,
    width: 43,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 174,
    y: 113,
    width: 27,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 174,
    y: 117,
    width: 27,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 174,
    y: 122,
    width: 27,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "128 112.902188 126.499917 110.451251 125.000167 108 123.500083 110.451251 122 112.902188 123.611731 112.902188 123.611731 120 126.388269 120 126.388269 112.902188"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 223.5,
    cy: 151.5,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 226,
    cy: 152,
    r: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#3F3D56",
    points: "215.695187 160 241 170.504953 240.209176 173 225.645741 171.358358 201 160.459598 214.706578 162.03545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.884119,170 L270.21108,66.0424925 L277.840018,52.3371688 L277.866808,52.2049084 C277.891417,52.0839896 278.451513,49.2193092 277.073784,47.1447529 C276.371666,46.1023255 275.272789,45.4020697 274.040172,45.2115927 C269.829701,44.4129789 260.41037,44.0195034 260.011553,44.0031103 L259.936348,44 L259.861788,44.0103016 C259.604406,44.0458137 253.584581,44.9359919 252.223754,50.2537353 L245.674437,62.3118043 L245.648684,62.3976018 L216,161.003729 L217.63166,161.505811 L247.254579,62.9854751 L253.825805,50.8867732 L253.852455,50.7755761 C254.81471,46.7738881 259.415039,45.8377008 260.026901,45.7305816 C260.989157,45.7721189 269.842233,46.1706491 273.725755,46.9073145 C274.505432,47.0148423 275.204923,47.4478804 275.654384,48.1012819 C276.503524,49.3732064 276.29098,51.2459056 276.216162,51.7382061 L268.634,65.3596167 L268.60684,65.4494952 L237.252714,169.496881 L238.884119,170 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3F3D56",
    transform: "translate(254.415387, 75.449895) rotate(-79.762140) translate(-254.415387, -75.449895) ",
    points: "253.556147 63.8664807 255.274627 63.8664807 255.274627 87.0333089 253.556147 87.0333089"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3F3D56",
    transform: "translate(250.057285, 89.761354) rotate(-78.464690) translate(-250.057285, -89.761354) ",
    points: "249.19805 78.2103886 250.916521 78.2103886 250.916521 101.31232 249.19805 101.31232"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3F3D56",
    transform: "translate(242.143155, 115.750229) rotate(-74.032140) translate(-242.143155, -115.750229) ",
    points: "241.283937 104.257182 243.002373 104.257182 243.002373 127.243275 241.283937 127.243275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#3F3D56",
    points: "245.932754 161 246.561726 159.397633 225.027951 150.988896 223.970421 139.57089 244.069157 147.057298 250.580402 156.452784 252 155.474834 245.180257 145.634369 222 137 223.407939 152.204106"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 253.5,
    cy: 162.5,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 257,
    cy: 163,
    r: 5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelModal);
export default __webpack_public_path__ + "static/media/cancelModal.db7409c4ab528faf6e76aeea333ea446.svg";
export { ForwardRef as ReactComponent };